import { FormFields } from 'app/modules/filingFormGenerator/models';
import {
  prefixFields,
  selectField,
} from 'app/modules/goAML/formConfig/fields/fieldBuilders';
import { getPersonTransactionFields } from 'app/modules/goAML/formConfig/fields/personFields';
import { GoamlReferenceTables } from 'app/modules/goAML/queries/useGetGoamlFiuConfig';

type FieldValues = Record<string, any>;

const getSignatoryRawFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  selectField({
    name: 'is_primary',
    label: 'Is primary?',
    options: [
      { value: '0', text: 'No' },
      { value: '1', text: 'Yes' },
    ],
    defaultValue: '1',
  }),
  selectField(
    {
      name: 'role',
      label: 'Role',
      required: true,
      refTable: 'account_person_role',
    },
    referenceTables,
  ),
];

export const getSignatoryFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getSignatoryRawFields(referenceTables),
  ...prefixFields('t_person', getPersonTransactionFields(referenceTables)),
];

export const getSignatoryMyClientFields = (
  referenceTables: GoamlReferenceTables,
): FormFields<FieldValues> => [
  ...getSignatoryRawFields(referenceTables),
  ...prefixFields(
    't_person',
    getPersonTransactionFields(referenceTables, { myClient: true }),
  ),
];
